import { render, staticRenderFns } from "./SubmissionSuccess.vue?vue&type=template&id=14a1a569&scoped=true&"
import script from "./SubmissionSuccess.vue?vue&type=script&lang=js&"
export * from "./SubmissionSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionSuccess.vue?vue&type=style&index=0&id=14a1a569&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a1a569",
  null
  
)

export default component.exports